import { ITokenResponse, ITokenResponseNew } from "../../services/user/user.interface";

import { CreateProfileFormType } from "../../services/user-create/user-create.schema";
import { IUserItemResponse } from "../../services/user-detail/user-detail.interface";
import { IUserStatusResponse } from "../../services/user-status/user-status.interface";
import { actionTypes } from "./user.actions";

export interface IUserState {
  emailSignIn: string | null;
  phoneSignIn: string | null;
  createProfile: CreateProfileFormType | null;
  token: ITokenResponse | null;
  user: IUserItemResponse | null;
  userStatus: IUserStatusResponse | null;
  tokenNew: ITokenResponseNew | null;
  location: string | null;
  inviteLink: string | null;
  referralCode: string | null;
}

const initialState: IUserState = {
  emailSignIn: null,
  phoneSignIn: null,
  createProfile: null,
  token: null,
  tokenNew: null,
  user: null,
  userStatus: null,
  location: null,
  inviteLink: null,
  referralCode: null,
};

export const userReducer = (
  state: IUserState = initialState,
  action: { type: string, payload?: any },
) => {
  switch (action.type) {
  case actionTypes.SET_EMAIL_SIGN_IN:
    return {
      ...state,
      emailSignIn: action.payload,
    };
  case actionTypes.SET_PHONE_SIGN_IN:
    return {
      ...state,
      phoneSignIn: action.payload,
    };
  case actionTypes.SET_CREATE_PROFILE:
    return {
      ...state,
      createProfile: action.payload,
    };
  case actionTypes.SET_TOKEN:
    return {
      ...state,
      token: action.payload,
    };
  case actionTypes.SET_USER_PROFILE:
    return {
      ...state,
      user: action.payload,
    };
  case actionTypes.SET_USER_STATUS:
    return {
      ...state,
      userStatus: action.payload,
    };
  case actionTypes.SET_TOKEN_NEW:
    return {
      ...state,
      tokenNew: action.payload,
    };
  case actionTypes.SET_LOCATION:
    return {
      ...state,
      createProfile: state.createProfile ? { ...state.createProfile, location: action.payload } : null,
    };
  case actionTypes.SET_INVITE_REFERRAL_LINK:
    return {
      ...state,
      inviteLink: action.payload.inviteLink,
      referralCode: action.payload.referralCode,
    };
  default:
    return state;
  }
};
